import Action, { ActionFilter, ActionTypeSelected, ActionTags, ActionType, ActionAddressChanged, ActionPropsChanged } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import FilterState from '../State/FilterState'

const actionFilterShow = (oldState: FilterState, action: Action): FilterState => {
    return { ...oldState, isOpen: (action as ActionFilter).isOpen }
}

const actionTypeSelected = (oldState: FilterState, action: Action): FilterState => {
    let id = (action as ActionTypeSelected).id

    return { ...oldState, filter: { ...oldState.filter, fileTypeId: id, propertyValueList: [] } }
}

const actionTags = (oldState: FilterState, action: Action): FilterState => {
    let ids = (action as ActionTags).ids
    return { ...oldState, filter: { ...oldState.filter, tags: ids } }
}

const actionProps = (oldState: FilterState, action: Action): FilterState => {
    let { id, value, from } = (action as ActionPropsChanged)
    let props = [...oldState.filter.propertyValueList]

    let index = props.findIndex((v, i, a) => {
        return v.propertyId === id
    })
    if (index === -1) {
        props.push(from ? {
            propertyId: id,
            propertyValue1: value,
            propertyValue2: undefined
        } : {
            propertyId: id,
            propertyValue1: undefined,
            propertyValue2: value
        })
    } else {
        if (from) {
            props[index].propertyValue1 = value === '' ? undefined : value
        } else {
            props[index].propertyValue2 = value === '' ? undefined : value
        }
    }


    return {
        ...oldState, filter: {
            ...oldState.filter, propertyValueList: props.filter((vv, aa, oo) => {
                return vv.propertyValue1 !== undefined || vv.propertyValue2 !== undefined
            })
        }
    }
}

const actionAddress = (oldState: FilterState, action: Action): FilterState => {
    let text = (action as ActionAddressChanged).text
    return { ...oldState, filter: { ...oldState.filter, address: text } }
}
const reset = (oldState: FilterState, action: Action): FilterState => {
    return {
        isOpen: false, filter: {
            address: '',
            fileTypeId: 0,
            propertyValueList: [],
            tags: []
        }
    }
}
type Process = (oldState: FilterState, action: Action) => FilterState

export const FilterReducer: Reducer<FilterState, Action> = (state: FilterState = {
    isOpen: false, filter: {
        address: '',
        fileTypeId: 0,
        propertyValueList: [],
        tags: []
    }
}, action: Action): FilterState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.FILTER_IS_OPEN, actionFilterShow)
    actionMap.set(ActionType.FILTER_TYPE_SELECTED, actionTypeSelected)
    actionMap.set(ActionType.FILTER_TAGS_CHANGED, actionTags)
    actionMap.set(ActionType.FILTER_ADDRESS_CHANGED, actionAddress)
    actionMap.set(ActionType.FILTER_PROPS_CHANGED, actionProps)
    actionMap.set(ActionType.FILTER_RESET, reset)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


